import type { ProjectDocumentV2 } from '../project/ProjectDocument.js'
import { documentsSemanticallyEqual } from '../store/commands.js'

export interface LegacyProjectBridgeGate {
  readonly acknowledged: boolean
  /** False means the candidate must not be synchronized into the runtime. */
  accept(candidate: ProjectDocumentV2): boolean
}

/**
 * A hydrated V2 project owns the runtime until the React compatibility facade
 * proves an exact semantic round trip. This prevents stale/default V1 state
 * from winning merely because an effect ran first.
 */
export function createLegacyProjectBridgeGate(
  hydratedProject: ProjectDocumentV2,
): LegacyProjectBridgeGate {
  let acknowledged = false
  return {
    get acknowledged() { return acknowledged },
    accept(candidate) {
      if (acknowledged) return true
      if (documentsSemanticallyEqual(hydratedProject, candidate)) acknowledged = true
      return false
    },
  }
}
